import React from "react";

export const Page404: React.FC = () => {
  return <>404</>;
};
export default React.memo(Page404);
